import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserDefinedFieldsRoutingModule } from './user-defined-fields-routing.module';
import { UserDefinedFieldsComponent } from './user-defined-fields.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Select2Module } from 'ng-select2-component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InvestorRoutingModule } from 'src/app/pages/fund-information/investors/investors.routing';


@NgModule({
  declarations: [
    UserDefinedFieldsComponent
  ],
  imports: [
    CommonModule,
    UserDefinedFieldsRoutingModule,
    SharedModule,
    Select2Module,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MatSelectModule,
    InvestorRoutingModule,
  ]
})
export class UserDefinedFieldsModule { }
